(() => {
  if (!document.body.classList.contains('template-product')) return;
  const mobile = window.matchMedia('(max-width: 1023px)');
  const selector = '[data-product-single-media-slider]';
  let gesture = null;
  const reset = () => { gesture = null; };
  document.addEventListener('touchstart', (event) => {
    reset();
    if (!mobile.matches || event.touches.length !== 1) return;
    const gallery = event.target.closest(selector);
    if (!gallery || gallery.classList.contains('has-media-active')) return;
    if (event.target.closest('button, input, video, model-viewer, iframe')) return;
    gesture = { x: event.touches[0].clientX, y: event.touches[0].clientY, axis: null };
  }, { passive: true, capture: true });
  document.addEventListener('touchmove', (event) => {
    if (!gesture) return;
    if (event.touches.length !== 1 || !mobile.matches) { reset(); return; }
    const dx = Math.abs(event.touches[0].clientX - gesture.x);
    const dy = Math.abs(event.touches[0].clientY - gesture.y);
    if (!gesture.axis && Math.max(dx, dy) >= 4) gesture.axis = dx > dy ? 'x' : 'y';
    if (gesture.axis === 'x' && event.cancelable) event.preventDefault();
  }, { passive: false, capture: true });
  document.addEventListener('theme:scroll', (event) => {
    if (gesture && gesture.axis === 'x') event.stopImmediatePropagation();
  }, { capture: true });
  document.addEventListener('touchend', reset, { passive: true, capture: true });
  document.addEventListener('touchcancel', reset, { passive: true, capture: true });
  window.addEventListener('blur', reset);
  const stabilize = () => {
    document.querySelectorAll(selector).forEach((gallery) => {
      const slider = window.themeVendor && window.themeVendor.Flickity.data(gallery);
      if (!slider) return;
      if (!gallery.hasAttribute('data-msn-adaptive-height')) {
        gallery.dataset.msnAdaptiveHeight = String(slider.options.adaptiveHeight);
      }
      const adaptiveHeight = mobile.matches ? false : gallery.dataset.msnAdaptiveHeight === 'true';
      if (slider.options.adaptiveHeight !== adaptiveHeight) {
        slider.options.adaptiveHeight = adaptiveHeight;
        slider.resize();
      }
    });
  };
  document.addEventListener('DOMContentLoaded', stabilize);
  document.addEventListener('theme:resize:width', stabilize);
  document.addEventListener('shopify:section:load', stabilize);
  mobile.addEventListener('change', () => { reset(); stabilize(); });
})();
